module.exports = __webpack_public_path__ + "static/media/cie.24bb9ab3.png";